<template>
  <div id="filtros">
    <div class="">
      <div class="card-body">
        <div class="row d-flex justify-content-end">
          <!-- <div class="col-sm-6 d-flex justify-content-center justify-content-sm-start align-items-center">
            <slot name="pagination"></slot>
          </div> -->
          <div class="col-sm-6 text-right text-sm-right">
            <button class="btn btn-info btn-sm-block mr-2" id="btnFiltro" v-b-toggle.collapse-filtros
              @click="showFiltros = !showFiltros">
              <i class="fas fa-filter mr-2"></i>
              <span v-if="!showFiltros">
                <!-- Mostrar filtros -->
              </span>
              <span v-if="showFiltros">
                <!-- Esconder filtros -->
              </span>
            </button>
            <button :style="bgColorButtonCriticidade" class="btn btn-info btn-sm-block" @click="refreshPage()"><i
                class="fa fa-undo"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-collapse id="collapse-filtros">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              Filtros
            </div>
            <div class="card-body pt-2 pb-2">
              <!-- <form action="" class="form"> -->

              <indicadores-resumo-externa></indicadores-resumo-externa>

              <Hr />
              <div class="row">
                <div class="form-group col-md-3">
                  <label>{{ $t('Fornecedor') }}</label>
                  <v-select id="selectFornecedor" :options="getFornecedores" v-model="internalFilters.fornecedor">
                  </v-select>
                </div>

                <form action="" class="form col-md-9">
                  <div class="row">
                    <div class="form-group col-md-2">
                      <label>CÓDIGO OS</label>
                      <input type="number" v-model="internalFilters.codigo" class="form-control" placeholder="99999" />
                    </div>
                    <div class="form-group col-md-2">
                      <label>{{ $t('Placa') }}</label>
                      <v-select :options="veiculos" @input="internalFilters.singlePlaca = $event" placeholder="Placa">
                      </v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>{{ $t('Tipo') }}</label>
                      <select v-model="internalFilters.tipo" @change="internalFilters.tipo = $event.target.value"
                        class="form-control">
                        <option value="">Todos</option>
                        <option v-for="(tipo, index) in osTipos" :value="tipo.nr_sequencial" :key="index">{{
                          tipo.ds_tipo }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>{{ $t('Ordenar') }}</label>
                      <select class="form-control" v-model="internalFilters.ordenation" placeholder="Ordenar">
                        <option value="ASC">{{ $t('Antigas Primeiro') }}</option>
                        <option value="DESC">{{ $t('Recentes Primeiro') }}</option>
                      </select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>{{ $t('Criticidade') }}</label>
                      <select class="form-control" v-model="internalFilters.criticidade" placeholder="Criticidade">
                        <option value="ASC">{{ $t('Maior') }}</option>
                        <option value="DESC">{{ $t('Menor') }}</option>
                      </select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>{{ $t('Segmentos') }}</label>
                      <v-select :options="grupos" @input="internalFilters.segmento = $event" placeholder="Segmento">
                      </v-select>
                    </div>
                    <div class="form-group col-md-4">
                      <label>{{ $t('Criado por') }}</label>
                      <v-select :options="getAbertoPorExterna" label="ds_colaborador"
                        :reduce="aberta_por => aberta_por.nr_sequencial" v-model="internalFilters.aberta_por"
                        placeholder="Usuário">
                      </v-select>
                    </div>
                    <div class="form-group d-none col-md-4">
                      <label>{{ $t('Período') }}</label>
                      <div class="row">
                        <div class="col-6">
                          <input type="date" class="form-control" v-model="internalFilters.de" />
                        </div>
                        <div class="col-6">
                          <input type="date" class="form-control" v-model="internalFilters.ate" />
                        </div>
                      </div>
                    </div>
                    <div class="form-group d-none col-md-2">
                      <label>{{ $t('Execução') }}</label>
                      <select class="form-control" v-model="internalFilters.executada">
                        <option value="">{{ $t('Todos') }}</option>
                        <option :value="0">{{ $t('Pendentes') }}</option>
                        <option :value="1">{{ $t('Finalizadas') }}</option>
                      </select>
                    </div>
                  </div>
                </form>
              </div>
              <!-- </form> -->
            </div>
            <div class="card-footer text-right">
              <button class="btn btn-info btn-sm-block float-sm-right" @click="applyFilters">
                <i class="fas fa-filter"></i> {{ $t('Aplicar filtro') }}
              </button>
              <button class="btn btn-outline-dark mr-2 btn-sm-block" @click="resetFilters">
                <i class="fas fa-times"></i> {{ $t('Limpar filtros') }}
              </button>
              <button class="btn btn-outline-dark mr-2 btn-sm-block" v-b-toggle.collapse-filtros
                @click="esconderFiltros()">
                <i class="fas fa-eye-slash"></i> {{ $t('Esconder filtros') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>

  </div>
</template>

<script>
import IndicadoresResumoExterna from '@/components/IndicadoresResumoExterna'

export default {
  data() {
    return {
      isSidebarOpen: false,
      showFiltros: false,
      fornecedor: '',
      refreshFilter: 0
    }
  },

  components: {
    IndicadoresResumoExterna

  },

  computed: {
    osTipos() {
      const items = this.$store.getters['osTipo/items']

      if (!items) {
        this.$store.dispatch('osTipo/fetchFromApi')
      }

      return items
    },
    veiculos() {
      const itemsFiltros = this.$store.getters['veiculo/itemsFiltro']

      if (!itemsFiltros) {
        this.$store.dispatch('veiculo/fetchFromApiFiltro')
        return []
      }

      return itemsFiltros.map(item => {
        return item.nr_placa
      })
    },

    getFornecedores() {
      const fornecedores = this.$store.getters['filial/fornecedores']

      if (!fornecedores) {
        this.$store.dispatch('filial/getFornecedores')
        return []
      }

      return fornecedores.map(fornecedor => {
        return {
          ...fornecedor,
          label: fornecedor.ds_fornecedor
        }
      })
    },

    filtros() {
      return this.$store.getters['os/filters']
    },

    internalFilters() {
      return { ...this.filtros }
    },

    grupos() {
      const grupos = this.$store.getters['frotaConjunto/grupos']

      if (!grupos) {
        this.$store.dispatch('frotaConjunto/getGrupos', { operacao: 0 })
        return []
      }

      return grupos.map(grupo => {
        return grupo.ds_grupo
      })
    },
    bgColorButtonCriticidade() {
      const filter = this.filtros.nr_nivel

      switch (filter) {
        case 0:
          return 'background-image: linear-gradient(45deg, #531218, #dc3646) !important;'
        case 1:
          return 'background-image: linear-gradient(45deg, #763c0a, #fd7f15) !important;'
        case 2:
          return 'background-image: linear-gradient(45deg, rgb(100 78 12), rgb(255 193 8)) !important;'
        case 3:
          return 'background-image: linear-gradient(45deg, #053a72, #007bff) !important;'
        default:
          return 'background: linear-gradient(45deg, #12570d, #1d9c14)!important;'
      }
    },

    getAbertoPorExterna() {
      const aberta_por = this.$store.getters['os/aberta_por']

      if (!Array.isArray(aberta_por)) {
        this.$store.dispatch('os/getAbertoPor')
        return []
      }

      return aberta_por.map(item => ({
        ...item,
        label: item.ds_colaborador
      }))
    },
  },
  methods: {
    refreshPage() {
      location.reload()
    },
    applyFilters() {
      let filters = { ...this.internalFilters }

      if(this.internalFilters.fornecedor){
        filters.fornecedor = this.internalFilters.fornecedor.nr_sequencial
      }

      this.$store.commit('os/setFilters', { filters: filters })
      this.$emit('update-filters', { filters: filters })

      this.updateFilters()
      document.getElementById('btnFiltro').click()
    },

    updateFilters(newFilters) {
      this.$store.dispatch('os/reset')
      this.fetchItemsFromApi()
    },

    fetchItemsFromApi() {
      this.$store.dispatch('os/fetchFromExternas')
    },

    resetFilters() {
      const filters = {
        placa: '',
        tipo: '',
        de: '',
        ate: '',
        codigo: '',
        segmento: '',
        fornecedor: '',
        aberta_por: ''
      }
      this.$store.commit('os/setFilters', { filters: filters })
      this.$emit('update-filters', { filters: filters })
    },

    esconderFiltros() {
      this.showFiltros = !this.showFiltros
      this.$scrollTo('#osList')
    }
  },
  created(){
    let filters = {
      placa: '',
      tipo: '',
      de: '',
      ate: '',
      codigo: '',
      origem: 'E'
    }

    this.$store.commit('os/setFiltersFiltro', { filters: filters })
    this.$store.dispatch('os/getAbertoPor')
  }
}
</script>
